import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import fitty from 'fitty'
import { Sex } from '@/firebase/firestore/Sex'
import { mapAmoungUsCreatorInfo } from '../config'

type Props = {
  targetId: string
  fontFamily: string
  fontColor: string
  uid: string
  name: string
  sex: Sex
  platform: Array<0 | 3 | 4>
  voiceChat: Array<0 | 1 | 3 | 4 | 100>
  playTimeWeekDayBegin: string
  playTimeWeekDayEnd: string
  playTimeWeekEndBegin: string
  playTimeWeekEndEnd: string
  playStyle: string
  hitokoto: string
  favoriteCrews: number[]
}

/* なみちゃんカード */
export const AmongUs3: React.FC<Props> = ({
  targetId,
  fontFamily,
  fontColor,
  uid,
  name,
  sex,
  playStyle,
  platform,
  voiceChat,
  playTimeWeekDayBegin,
  playTimeWeekDayEnd,
  playTimeWeekEndBegin,
  playTimeWeekEndEnd,
  hitokoto,
  favoriteCrews,
}) => {
  useEffect(() => {
    fitty('#name', {
      maxSize: 20,
      minSize: 18,
    })
    fitty('#amongusId', {
      maxSize: 20,
      minSize: 18,
    })
    fitty('#playStyle', {
      maxSize: 18,
      minSize: 14,
    })
    fitty('#hitokoto', {
      maxSize: 18,
      minSize: 14,
    })
  }, [])
  return (
    <Container id={targetId} fontFamily={fontFamily} fontColor={fontColor}>
      <img
        width="2048"
        height="1364"
        src={mapAmoungUsCreatorInfo.__nyan299.profileCardImageURL}
      />
      <TimeYear>{new Date().getFullYear()}</TimeYear>
      <TimeMonth>{new Date().getMonth() + 1}</TimeMonth>
      <TimeDay>{new Date().getDate()}</TimeDay>
      <Name>
        <span id="name">{name}</span>
      </Name>
      <ID>
        <span id="amongusId">{uid}</span>
      </ID>
      <PlayTimeWeekDay>
        平日 {playTimeWeekDayBegin}時〜{playTimeWeekDayEnd}時
      </PlayTimeWeekDay>
      <PlayTimeWeekEnd>
        休日 {playTimeWeekEndBegin}時〜{playTimeWeekEndEnd}時
      </PlayTimeWeekEnd>
      {playStyle === 'beginner' && <PlayStyleBeginner />}
      {playStyle === 'enjoy' && <PlayStyleEnjoy />}
      {playStyle === 'serious' && <PlayStyleSerious />}
      <Hitokoto>
        <span id="hitokoto">{hitokoto}</span>
      </Hitokoto>
      {sex === 1 && <Sex1 />}
      {sex === 0 && <Sex0 />}
      {platform.includes(0) && <Platform0 />}
      {platform.includes(4) && <Platform1 />}
      {platform.includes(3) && <Platform2 />}
      {voiceChat.includes(3) && <VCDiscord />}
      {voiceChat.includes(1) && <VCLine />}
      {voiceChat.includes(0) && <VCSkype />}
      {voiceChat.includes(4) && <VCNg />}
      {(voiceChat.includes(3) ||
        voiceChat.includes(1) ||
        voiceChat.includes(0)) && <VCOk />}
      {favoriteCrews.includes(0) && <Crew0 color={fontColor} />}
      {favoriteCrews.includes(1) && <Crew1 color={fontColor} />}
      {favoriteCrews.includes(2) && <Crew2 color={fontColor} />}
      {favoriteCrews.includes(3) && <Crew3 color={fontColor} />}
      {favoriteCrews.includes(4) && <Crew4 color={fontColor} />}
      {favoriteCrews.includes(5) && <Crew5 color={fontColor} />}
      {favoriteCrews.includes(6) && <Crew6 color={fontColor} />}
      {favoriteCrews.includes(7) && <Crew7 color={fontColor} />}
      {favoriteCrews.includes(8) && <Crew8 color={fontColor} />}
      {favoriteCrews.includes(9) && <Crew9 color={fontColor} />}
      {favoriteCrews.includes(10) && <Crew10 color={fontColor} />}
      {favoriteCrews.includes(11) && <Crew11 color={fontColor} />}
    </Container>
  )
}

const Container = styled.div<{ fontFamily: string; fontColor: string }>`
  position: relative;
  width: 100%;
  line-height: 0;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ fontColor }) => fontColor};
    border-color: ${({ fontColor }) => fontColor};
  }
`

const TimeBase = styled.div`
  position: absolute;
  top: 11%;
  left: 69%;
  width: 20%;
  height: 12%;
  word-break: break-all;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 14px;

  span {
    font-weight: bold;
    text-align: center;
  }
`

const TimeYear = styled(TimeBase)``

const TimeMonth = styled(TimeBase)`
  left: 76.5%;
`

const TimeDay = styled(TimeBase)`
  left: 83%;
`

const Name = styled.span`
  position: absolute;
  top: 26%;
  left: 14.5%;
  width: 20%;
  height: 12%;
  word-break: break-all;
  align-items: center;
  justify-content: center;
  display: flex;

  span {
    font-weight: bold;
    text-align: center;
    line-height: 0.6;
  }
`

const ID = styled.span`
  position: absolute;
  top: 40%;
  left: 14.5%;
  width: 20%;
  height: 12%;
  word-break: break-all;
  align-items: center;
  justify-content: center;
  display: flex;

  span {
    font-weight: bold;
    text-align: center;
    line-height: 0.6;
  }
`

const PlayTimeWeekDay = styled.span`
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  top: 66%;
  left: 14%;
`

const PlayTimeWeekEnd = styled.span`
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  top: 71%;
  left: 14%;
`

const SexBase = styled.div`
  position: absolute;
  top: 27%;
  border: solid 3px;
  border-radius: 50%;
  width: 27px;
  height: 27px;
`

const Sex1 = styled(SexBase)`
  left: 35.5%;
`

const Sex0 = styled(SexBase)`
  left: 41%;
`

const PlatformBase = styled.div`
  position: absolute;
  top: 83%;
  left: 15.5%;
  border: solid 3px;
  border-radius: 50%;
  width: 28px;
  height: 28px;
`
const Platform0 = styled(PlatformBase)``
const Platform1 = styled(PlatformBase)`
  left: 25%;
`
const Platform2 = styled(PlatformBase)`
  left: 34.5%;
`

const VCBase = styled.div`
  position: absolute;
  top: 41%;
  left: 62.5%;
  border: solid 2px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
`

const VCDiscord = styled(VCBase)`
  top: 41%;
  left: 76.5%;
`

const VCLine = styled(VCBase)`
  top: 41%;
  left: 82.8%;
`

const VCSkype = styled(VCBase)`
  top: 41%;
  left: 89%;
`

const VCOk = styled(VCBase)`
  top: 31.5%;
  left: 77.8%;
`

const VCNg = styled(VCBase)`
  top: 31.5%;
  left: 85%;
`

const PlayStyleBase = styled.div`
  position: absolute;
  top: 47.8%;
  left: 16.3%;
  border: solid 2px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
`

const PlayStyleBeginner = styled(PlayStyleBase)``

const PlayStyleSerious = styled(PlayStyleBase)`
  left: 23%;
`

const PlayStyleEnjoy = styled(PlayStyleBase)`
  left: 30%;
  border-radius: 12px;
  width: 64px;
  height: 24px;
`

const CrewBase = styled.div<{ color: string }>`
  position: absolute;
  top: 32.5%;
  left: 51.5%;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-width: 1.5px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
`

const Crew0 = styled(CrewBase)``

const Crew1 = styled(CrewBase)`
  left: 55.3%;
`

const Crew2 = styled(CrewBase)`
  left: 59%;
`

const Crew3 = styled(CrewBase)`
  left: 63%;
`

const Crew4 = styled(CrewBase)`
  left: 67%;
`

const Crew5 = styled(CrewBase)`
  top: 41%;
  left: 51.5%;
`

const Crew6 = styled(CrewBase)`
  top: 41%;
  left: 55.3%;
`

const Crew7 = styled(CrewBase)`
  top: 41%;
  left: 59%;
`

const Crew8 = styled(CrewBase)`
  top: 41%;
  left: 63%;
`

const Crew9 = styled(CrewBase)`
  top: 41%;
  left: 67%;
`

const Crew10 = styled(CrewBase)`
  top: 48%;
  left: 51.5%;
`

const Crew11 = styled(CrewBase)`
  top: 48%;
  left: 55.3%;
`

const Hitokoto = styled.span`
  margin: auto;
  display: flex;
  position: absolute;
  top: 54%;
  left: 51%;
  height: 50%;
  width: 45%;
  word-break: break-all;
  text-align: center;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    line-height: 1.4;
  }
`
